import axios from 'axios';
import Vue from "vue";
import Vuex from "vuex";

import Dealers from '../../../used-vue/store/modules/dealers';
import CustomerData from '../../../used-vue/store/modules/customer-data';
import ElecTestDrive from "./ElecTestDrive.vue";
import { navigator } from "./navigator";
import debounce from 'lodash/debounce';
import ContactFormValidator from '../../../validation/ContactFormValidator';
import { customEvent, generateLeadEvent, trackPageView } from '../../../modules/tracking/AnalyticsEvents';

window.axios = axios;
window.ContactFormValidator = ContactFormValidator;

export default function (element) {
    const TestDriveElectricSectionVueAppData = JSON.parse(element.dataset.vueAppData);
    if (TestDriveElectricSectionVueAppData.includes('electric_and_hybrid')) {
        const index = TestDriveElectricSectionVueAppData.indexOf('electric_and_hybrid');
        TestDriveElectricSectionVueAppData.splice(index, 1, 'electric', 'hybrid');
    }
    const DeepLinkData = JSON.parse(element.dataset.deepLinkData);
    
    Vue.use(Vuex);

    Vue.mixin({
        methods: {
            gaTag(eventCategory = '', eventAction = '', eventLabel = '') {
                customEvent(eventCategory, eventAction, eventLabel, 0);
            },
            generateLeadEvent(name = 'Misc Event', value = 0, currency = 'GBP') {
                generateLeadEvent(name, currency, value);
            },
            trackPageView() {
                trackPageView();
            }
        }
    });

    const selectedBrands = [];
    if (typeof window.location.search != 'undefined') {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('brand')) {
            selectedBrands.push(searchParams.get('brand'));
        }
    }

    const store = new Vuex.Store({
        state: {
            model: [],
            deepLinkData: DeepLinkData,
            navigator: navigator,
            location: null,
            place: null,
            selectedOptions: {
                brand: [],
                model: [],
                bodystyle: [],
                filters:TestDriveElectricSectionVueAppData,
                preventNonTestDriveModelsAppearing: true,
                useElectricTestDriveOrder: true,
                showComingSoon: false
            },
            availableOptions: {
                brand: [],
                model: [],
                bodystyle: [],
            },
            date:null,
            searchDate:null,
            time:null,
            times:[],
            initialized: false,
            loadingOptions: true,
            loadingVehicles: true,
            loadingDays: true,
            vehicles: [],
            quoteValidDate: null,
            customerAddress: '',
            closedDays: [],
            bankHolidays: [],
            directionsLink: null,
            modelPage: false,
            dealerPage: false,
            datePage: false,
            detailsPage: false,
            scrollPosition: null
        },
        mutations: {
            savePosition(state, position) {
                state.scrollPosition = position;
            },
            setCustomerAddress(state, payload) {
                state.customerAddress = payload.customerAddress;
            },
            setModel(state, newModel) {
                newModel.model_title = newModel.model_title.replace('Citroen', 'Citroën');
                state.model = newModel;
            },
            setRegistration(state, registration) {
                state.registration = registration;
            },
            setVehicle(state, vehicle) {
                state.vehicle = vehicle;
            },
            setStep(state, step) {
                state.navigator.step = step;
            },
            setLocation(state, location) {
                state.location = location;
            },
            setPlace(state, place) {
                state.place = place;
            },
            setDealer(state, payload) {
                state.dealer = payload;
            },
            setDate(state, payload) {
                state.date = payload;
            },
            setTime(state, payload) {
                state.time = payload;
            },
            setSearchDate(state, payload) {
                state.searchDate = payload;
            },
            setSelectedModel(state, model) {
                state.model = model;
            },
            setVehicles(state, vehicles) {
                state.vehicles = vehicles;
            },
            setQuoteValidDate(state, quoteValidDate) {
                state.quoteValidDate = quoteValidDate;
            },
            setLoadingOptions(state, loadingOptions) {
                state.loadingOptions = loadingOptions;
            },
            setLoadingDays(state, loadingDays) {
                state.loadingDays = loadingDays;
            },
            setTimes(state, times) {
                state.times = times;
            },
            setDealerClosedDays(state, days) {
                state.closedDays = days;
            },
            setBankHolidays(state, days) {
                state.bankHolidays = days;
            },
            setLoadingVehicles(state, loadingVehicles) {
                state.loadingVehicles = loadingVehicles;
            },
            setDealerDirectionsLink(state, directionsLink) {
                state.directionsLink = directionsLink;
            },
            setModelPage(state, val) {
                state.modelPage = val;
            },
            setDealerPage(state, val) {
                state.dealerPage = val;
            },
            setDatePage(state, val) {
                state.datePage = val;
            },
            setDetailsPage(state, val) {
                state.detailsPage = val;
            },
            setVisited(state, step) {
                const currentStep = state.navigator.steps.find(
                    item => item.step === step
                );

                if (currentStep) {
                    currentStep.visited = true;
                }
            },
            setAvailableOptions(state, options) {
                if (typeof options !== 'object') {
                    return false;
                }
                Object.keys(options).forEach(key => {
                    if (typeof state.availableOptions[key] == 'undefined') {
                        return;
                    }
                    if (key == 'type') {
                        const niceTypes = [];
                        options[key].forEach(type => {
                            niceTypes.push(type.charAt(0).toUpperCase() + type.slice(1));
                        })
                        state.availableOptions[key] = niceTypes;
                        return;
                    }
                    if (key == 'model') {
                        const niceModels = [];
                        options[key].forEach(model => {
                            niceModels.push(model.charAt(0).toUpperCase() + model.slice(1));
                        })
                        state.availableOptions[key] = niceModels;
                        return;
                    }
                    if (key == 'brand') {
                        const niceBrands = [];
                        options[key].forEach(brand => {
                            if (brand == 'ds') {
                                niceBrands.push('DS');
                                return;
                            }
                            niceBrands.push(brand.charAt(0).toUpperCase() + brand.slice(1));
                        })
                        state.availableOptions[key] = niceBrands;
                        return;
                    }
                    state.availableOptions[key] = options[key];
                });
            },
            updateOptions(state, options) {
                if (typeof options !== 'object') {
                    return false;
                }
                Object.keys(options).forEach(key => {
                    if (typeof state.selectedOptions[key] == 'undefined') {
                        return;
                    }
                    state.selectedOptions[key] = options[key];
                });
            },
        },
        actions: {
            updateDealer({ getters, dispatch, commit }, payload) {
                commit('setLoadingDays', true);
                commit("setDealer", payload);
                dispatch('getDealerClosedDays')
                    .then(() => {
                        commit('setLoadingDays', false);
                        dispatch('navigatorStep', getters.currentStep.next);
                    }).catch(error => {
                        console.error('Error updating dealer:', error);
                        commit('setLoadingOptions', false);
                        throw error;
                    });
            },

            getDealerClosedDays({ commit, state }) {
                return new Promise((resolve, reject) => {
                    commit('setLoadingOptions', true);
                    axios.get('/api/dealer-closed-days', {
                        params: {
                            dealer: state.dealer.id,
                            service_type: 'Sales',
                        }
                    })
                    .then(response => {
                        const dealerClosedDays = response.data || [];
                        commit('setDealerClosedDays', dealerClosedDays);
                        resolve(response);
                    })
                    .catch(error => {
                        console.error('Error setting times');
                        console.error(error);
                        reject(error);
                    });
                });
            },

            getTimes({ commit, state }) {
                return new Promise((resolve, reject) => {
                    commit('setLoadingOptions', true);
                    axios.get('/api/dealer-opening-times', {
                        params: {
                            dealer: state.dealer.id,
                            service_type: 'Sales',
                            interval: '60 minutes',
                            date: state.searchDate,
                        }
                    })
                    .then(response => {
                        const dayTimes = response.data || [];
                        commit('setTimes', dayTimes);
                        resolve(response);
                    })
                    .catch(error => {
                        console.error('Error setting times');
                        console.error(error);
                        reject(error);
                    });
                });
            },

            getOptions:
            debounce(({ commit, state }) => {
                commit('setLoadingOptions', true);
                return new Promise((resolve, reject) => {
                    axios.get('/api/our-range-electric/options', {
                        params: state.selectedOptions
                    })
                        .then(response => {
                            commit('setLoadingOptions', false);
                            commit('setAvailableOptions', response.data);
                            resolve(response);
                        })
                        .catch(error => {
                            console.error('Error getting options');
                            console.error(error);
                            reject(error);
                        });
                });
            },
                350,
                {
                    leading: false,
                    trailing: true
                }
            ),
        getVehicles:
            debounce(({ commit, state }, modelId) => {
                commit('setLoadingVehicles', true);
                return new Promise((resolve, reject) => {
                    axios.get('/api/our-range-electric', {
                        params: state.selectedOptions
                    })
                        .then(response => {
                            commit('setLoadingVehicles', false);
                            commit('setQuoteValidDate', response.data.meta.quote_valid_date);
                            const vehicles = [];
                            response.data.data.forEach((vehicle) => {
                                vehicles.push(vehicle);
                            });
                            commit('setVehicles', vehicles);
                            if(modelId != null){
                                let vehicle = vehicles.find(obj => obj.new_model_id == modelId)
                                commit('setSelectedModel', vehicle)
                            }
                            resolve(response);
                        })
                        .catch(error => {
                            console.error('Error getting vehicles');
                            console.error(error);
                            reject(error);
                        });
                });
            },
                350,
                {
                    leading: false,
                    trailing: true
                }
            ),
            getVehicle({ dispatch }, modelId) {
                dispatch('getVehicles', modelId)
            },

            getOptionsAndVehicles({ commit, dispatch, state }) {
                return Promise.all([
                    dispatch('getVehicles'),
                    dispatch('getOptions'),
                ]).then(() => {
                    commit('setLoadingOptions', false);
                }).catch(error => {
                    console.error('Error updating vehicles and options:', error);
                    commit('setLoadingOptions', false);
                    throw error;
                });
            },
            getOpeningTimes({ commit, dispatch }) {
                dispatch('getTimes');
            },

            updateOptions({ commit, dispatch }, options) {
                commit('updateOptions', options);
                dispatch('getOptionsAndVehicles');
            },
            navigatorStep({ commit, dispatch }, step) {
                commit("setStep", step);
            },
            triggerEvent({ getters, commit }) {
                const currentStep = getters.currentStep;

                if (currentStep) {
                    const visitedStep = currentStep.visited
                        ? 're visited'
                        : 'visited';

                    customEvent(
                        'Electric Car - Test Drive Form',
                        visitedStep,
                        currentStep.tag,
                        0
                    );
                    commit('setVisited', currentStep.step);
                }
            },
            resetFlow({ commit, state }) {
                commit("setStep", state.navigator.steps[0].step);
                commit("setRegistration", "");
                commit("setVehicle", null);
            },
            fetchVehicleLocation({ commit, state }) {
                return new Promise((resolve, reject) => {
                    axios
                    .post('/api/clean-air-zone/vehicle-location', {
                        registration: state.registration,
                        location: state.location,
                    })
                    .then((response) => {
                        commit("setVehicle", response.data);
                        resolve(response.data);
                    })
                    .catch(error => {
                        console.error(error);
                        reject(error);
                    });
                });
            },
        },
        getters: {
            currentStep(state) {
                return state.navigator.steps.find(
                    (step) => step.step === state.navigator.step
                );
            },
            currentOptions(state) {
                return state.selectedOptions
            },
            model(state) {
                return state.model
            },
            getDealerBankHolidays(state) {
                return state.bankHolidays
            },
            getDealerClosedDays(state) {
                return state.closedDays
            }
        },
        modules: {
            CustomerData,
            Dealers
        }
    });

    const vueApp = new Vue({
        el: element,
        components: {
            ElecTestDrive,
        },
        store: store,
        template: "<ElecTestDrive />",
    });
}
